import $ from 'jquery';



   
        $('#quitar-mute').on('click', function (){
          if( $('video').prop('muted', true) )
          {
            $('video').prop('muted', false);
            $('#quitar-mute').css('display','none');
            $('#mute-video').css('display','block');
          }
        });
      
        $('#mute-video').on('click', function (){
          $('video').prop('muted', true);
          $('#quitar-mute').css('display','block');
          $('#mute-video').css('display','none');
        }); 

      


        let href = $('.btn-comprar-ciudad').attr('href');

    $('.btnEntradas').attr('href', href);



// WEBPACK FOOTER //
// ./scripts/routes/single-ciudad.js